/* eslint-disable react/no-unescaped-entities */
import React from "react";
import "./Home.scss";
import { Link } from "react-router-dom";
import {
  anvImg1,
  baloonsImg1,
  bdayImg2,
  galleryImg2,
  galleryImg3,
  galleryImg4,
  galleryImg5,
  galleryImg6,
  galleryImg7,
  galleryImg8,
  galleryImg9,
  haldiImg1,
  mandapImg1,
  maskImg,
  stageImg1,
  stageImg2,
} from "../../assests/images";
import demoVideo from "../../assests/video/demo-video.mp4";
import Fancybox from "../../components/LightBox/LightBox";
import Testimonials from "../../components/Testimonials/Testimonials";
import { Fade } from "react-awesome-reveal";
import serviceList from "../../utils/Services";
import "swiper/css";
import "swiper/css/effect-fade";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper";

function Home() {
  return (
    <>
      <div className="home-wrap">
        <div className="h-banner">
          <div className="inner container">
            <div className="l-col">
              <Fade cascade damping={0.2}>
                <h1>
                  WowWish<span>Momemts</span>
                </h1>
                <h6>
                  We organized your special events &
                  <b> Make it forever special.</b>
                </h6>
                <p>
                  {" "}
                  Marriages || Receptions || Engagement || Haldi Decor || Groom
                  || Bride || Birthdays
                </p>
                <div className="btn-wrap">
                  <Link className="btn" to={`mailto:wowwishMoments@gmail.com`}>
                    CONTACT US
                  </Link>
                </div>
              </Fade>
            </div>
            <div className="r-col">
              <Swiper
                effect={"fade"}
                loop={true}
                modules={[EffectFade, Autoplay]}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                }}
                className="b-slider"
              >
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={stageImg1}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={galleryImg4}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={haldiImg1}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={baloonsImg1}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={stageImg2}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={mandapImg1}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img className="b-img" src={anvImg1} alt="WowWishMoments" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="img">
                    <img
                      className="mask-img"
                      src={maskImg}
                      alt="WowWishMoments"
                    />
                    <img
                      className="b-img"
                      src={bdayImg2}
                      alt="WowWishMoments"
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
      <section className="sec-1 spacing">
        <div className="container">
          <div className="row">
            <div className="r-col">
              <Fade cascade damping={0.2}>
                <h3>About Us</h3>
                <h5>
                  We organised your all special events. Make it forever special.
                </h5>
                <p>
                  WowWishMoments is a main occasion coordinator and decorator
                  situated in Meerut with 2 years of involvement with making
                  remarkable minutes for our clients. At WowWishMoments, we
                  accept that each occasion is novel and should be customized by
                  the inclinations and style of the host. Our group of capable
                  experts is focused on conveying uncommon administrations and
                  making vital encounters for{" "}
                  <b>
                    all events, from weddings and birthday events ato corporate
                    occasions and get-togethers.
                  </b>
                </p>
                <p>
                  {" "}
                  Marriages || Receptions || Engagement || Haldi Decor || Groom
                  || Bride || Birthdays
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-2  spacing ">
        <div className="container">
          <div className="row">
            <div className="r-col">
              <Fade cascade damping={0.2}>
                <h3>Our Services</h3>
                <h5>As per your needs, imagination, emotions and location.</h5>
              </Fade>
            </div>
          </div>
          <div className="services-wrap ">
            <div className="s-inner">
              {serviceList?.map((item, i) => {
                if (i < 9) {
                  return (
                    <div className="service-item" key={item.id}>
                      <div className="service-item-inner">
                        <Fade cascade damping={0.3}>
                          <Link to={item.link} className="si-img">
                            <img src={item.image} alt={item.name} />
                          </Link>
                          <div className="si-content">
                            <h6>
                              <Link className="animateLine" to={item.link}>
                                {item.name}
                              </Link>
                            </h6>
                            <p>{item.desc}</p>

                            <Link
                              className="btn"
                              to={`mailto:wowwishMoments@gmail.com?subject=Inquiry For ${item.name}`}
                            >
                              Enquiry Now
                            </Link>
                          </div>
                        </Fade>
                      </div>
                    </div>
                  );
                }
              })}
              <div className="service-item last-card">
                <div className="service-item-inner">
                  <Fade cascade damping={0.3}>
                    <div className="si-content">
                      <h6>
                        <Link className="animateLine" to={`/services`}>
                          View All Services
                        </Link>
                      </h6>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-3 spacing ">
        <div className="container">
          <div className="row">
            <div className="r-col">
              <Fade cascade damping={0.3}>
                <h3>Gallery</h3>
                <h5>As per your needs, imagination, emotions and location.</h5>
              </Fade>
            </div>
          </div>
          <div className="gallery-wrap">
            <div className="gallery-inner">
              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                }}
              >
                <a data-fancybox="gallery" href={galleryImg2}>
                  <img src={galleryImg2} />
                </a>
                <a data-fancybox="gallery" href={galleryImg3}>
                  <img src={galleryImg3} />
                </a>
                <a data-fancybox="gallery" href={galleryImg4}>
                  <img src={galleryImg4} />
                </a>
                <a data-fancybox="gallery" href={galleryImg5}>
                  <img src={galleryImg5} />
                </a>
                <a data-fancybox="gallery" href={galleryImg6}>
                  <img src={galleryImg6} />
                </a>
                <a data-fancybox="gallery" href={galleryImg7}>
                  <img src={galleryImg7} />
                </a>
                <a data-fancybox="gallery" href={galleryImg8}>
                  <img src={galleryImg8} />
                </a>
                <a data-fancybox="gallery" href={galleryImg9}>
                  <img src={galleryImg9} />
                </a>
              </Fancybox>
            </div>
          </div>
          <div className="btn-wrap">
            <Link to="/gallery" className="animateLine">
              View all
            </Link>
          </div>
        </div>
      </section>

      <section className="sec-4  spacing">
        <div className="container">
          <div className="row">
            <div className="r-col">
              <Fade cascade damping={0.3}>
                <h3>Videos</h3>
                <h5>As per your needs, imagination, emotions and location.</h5>
              </Fade>
            </div>
          </div>
          <div className="video-wrap">
            <div className="video-inner">
              <div className="video-item">
                <video controls muted autoPlay preload="auto">
                  <source src={demoVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>

              <div className="video-item">
                <video controls muted autoPlay preload="auto">
                  <source src={demoVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="video-item">
                <video controls muted autoPlay preload="auto">
                  <source src={demoVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="video-item">
                <video controls muted autoPlay preload="auto">
                  <source src={demoVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <div className="btn-wrap">
            <Link to="/gallery" className="animateLine">
              View all
            </Link>
          </div>
        </div>
      </section>

      <section className="sec-4  spacing">
        <div className="container">
          <div className="row">
            <div className="r-col">
              <Fade>
                <h3>Testimonials</h3>
              </Fade>
            </div>
            <Testimonials />
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
